<button
  (click)="toggleWatchlist($event)"
  [disabled]="isUpdating"
  [attr.aria-busy]="isUpdating"
  class="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 font-semibold border-2 text-sm sm:text-base disabled:cursor-wait disabled:opacity-60"
  [ngClass]="{
    'bg-red-500 text-white border-red-500 hover:bg-red-600 hover:border-red-600': isInWatchlist,
    'bg-white text-red-500 border-red-500 hover:bg-red-50': !isInWatchlist
  }"
  [title]="isInWatchlist ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'">
  <svg class="w-3 h-3 sm:w-4 sm:h-4 transition-colors" fill="currentColor" viewBox="0 0 24 24">
    <path
      *ngIf="!isInWatchlist"
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
      stroke="currentColor"
      stroke-width="2"
      fill="none" />
    <path
      *ngIf="isInWatchlist"
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
  </svg>
  <span *ngIf="!isInWatchlist" class="hidden sm:inline">{{ 'Dodaj do ulubionych' | translate }}</span>
  <span *ngIf="!isInWatchlist" class="sm:hidden">{{ 'Dodaj' | translate }}</span>
  <span *ngIf="isInWatchlist" class="hidden sm:inline">{{ 'Usuń z ulubionych' | translate }}</span>
  <span *ngIf="isInWatchlist" class="sm:hidden">{{ 'Usuń' | translate }}</span>
</button>
